import Vue from 'vue';
import Tooltip from './components/Tooltip.vue';
export default Vue.extend({
    components: { Tooltip },
    props: {
        paginationIsNeeded: { type: Boolean },
        changePaginationPage: { type: Function },
        handleManualChangeOfRowsPerPage: { type: Function },
        paginationObject: { type: Object },
        rowsPerPageOptionsWithLabels: { type: Array }
    },
    data() {
        return {
            newPageNumberHolder: 1
        };
    },
    computed: {
        pageNagivationButtons() {
            const { page, pages } = this.paginationObject;
            const morePagesOnTheLeft = page > 1;
            const morePagesOnTheRight = pages ? page < pages : false;
            return [
                {
                    action: 'first',
                    icon: 'mdi-chevron-double-left',
                    tooltip: 'First page',
                    isVisible: morePagesOnTheLeft
                },
                {
                    action: 'previous',
                    icon: 'mdi-chevron-left',
                    tooltip: 'Previous page',
                    isVisible: morePagesOnTheLeft
                },
                {
                    action: 'next',
                    icon: 'mdi-chevron-right',
                    tooltip: 'Next page',
                    isVisible: morePagesOnTheRight
                },
                {
                    action: 'last',
                    icon: 'mdi-chevron-double-right',
                    tooltip: 'Last page',
                    isVisible: morePagesOnTheRight
                }
            ];
        }
    },
    watch: {
        'paginationObject.page'(val) {
            this.newPageNumberHolder = val;
        }
    }
});
